import DonnutChart from "./graphics/donut-chart.tsx";
import PieChart from "./graphics/pie-chart.tsx";
import ScheduleChart from "./graphics/schedule-chart";
import BarChart from "./graphics/simple-bar-chart.tsx";

const ShowAdministrativeGraphics = ({ optionSelected }) => {
  return (
    <>
      {optionSelected === "" && (
        <div className="d-flex justify-content-center h-100 align-items-center">
          <div className="d-flex flex-column justify-content-center align-items-center h-100">
            <img
              alt="logo_alta_black_2"
              style={{ padding: "0% 20%" }}
              src={
                process.env.PUBLIC_URL +
                "/assets/img/logo_small_elevva_metrics.png"
              }
            />
            <div
              style={{ width: "50%", lineHeight: "1" }}
              className="mx-auto text-center"
            >
              <span
                style={{
                  fontSize: "calc(.4rem + .4vw)",
                }}
              >
                Selecciona la estadística que desees visualizar
              </span>
            </div>
          </div>
        </div>
      )}
      {optionSelected === "consumption" && (
          <div className="d-flex flex-column justify-content-center h-100 align-items-center gap-2">
            <PieChart type="plan" />
          </div>
      )}
      {optionSelected === "consumption_gender" && (
          <div className="d-flex flex-column justify-content-center h-100 align-items-center">
            <PieChart type="gender" />
          </div>
      )}
      {optionSelected === "services" && (
          <div className="d-flex justify-content-center h-100 align-items-center">
            <DonnutChart />
          </div>
      )}
      {optionSelected === "age" && (
          <div className="d-flex justify-content-center h-100 align-items-center">
            <DonnutChart type="age"/>
          </div>
      )}
      {optionSelected === "payment_method" && (
          <div className="d-flex justify-content-center h-100 align-items-center">
            <DonnutChart type="payment_method"/>
          </div>
      )}
      {optionSelected === "billing" && (
        <div className="d-flex justify-content-center h-100 align-items-center ">
          <BarChart />
        </div>
      )}
      {optionSelected === "user_joined" && (
          <div className="d-flex justify-content-center h-100 align-items-center">
            <BarChart type="joined" />
          </div>
      )}
      {optionSelected === "user_left" && (
          <div className="d-flex justify-content-center h-100 align-items-center">
            <BarChart type="left" />
          </div>
      )}
      {optionSelected === "schedule" && (
        <div className="d-flex w-100 justify-content-center h-100 align-items-center">
          <ScheduleChart />
        </div>
      )}
    </>
  );
};
export default ShowAdministrativeGraphics;
